import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setShowResourceSubmissionModal } from 'store/reducers/resource-submission/resource-submission-reducer';

export default function useResourceSubmissionHash() {
  const dispatch = useDispatch();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('#resource-submission')) {
      dispatch(setShowResourceSubmissionModal(true));
    }
  }, []);
}
